<template>
  <div class="main-app-bg" style="height: 100vh; text-align: center">
    <h2>Processing Invitation...</h2>
  </div>
</template>


<script>
export default {
  name: 'AccountRegistrationInvite',
  mounted() {
    // Make sure the invite code is correct
    if(!this.$route.params.code) {
      this.errorToast('Invalid Invitation')
      this.$router.push('/login')
      return
    }

    // Attempt to login using the invitation code
    // If successful, will use the response token as the login token for the account's owner user to continue the account activation process
    this.$apiService.coreService.authenticateAccountInvitation({ invitationCode: this.$route.params.code })
    .then(response => {
      // Setup auth token
      this.$authService.setAuthToken(response.data.token, true);
      this.$socketService.connect()

      // Direct to the dashboard. Will re-direct to account activation
      this.$router.push("/")

    })
    .catch(err => {
      this.displayNetworkError(err, 'Error processing invitation')
    })
  }
}
</script>